<script lang="ts" generics="TValues">
    import type { ItemType } from '$lib/components/Feed/FeedPostForm/Dropdown.svelte';
    import { categoryItems } from '$lib/components/Feed/Utils';
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import * as NewsfeedFiltersData from '$components/SearchHeader/NewsfeedFilters/NewsfeedFiltersData';
    import type { SelectOption } from '@melt-ui/svelte';
    import type { FeedPostTagEnum } from '$gql/graphql.js';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let form: Form<TValues, string>;
    export let newsfeedFiltersFields: NewsfeedFiltersData.Fields<TValues>;
    export let showFiltersField: Field<TValues, boolean>;

    function resetFilters() {
        form.dispatch(
            form
                .actions()
                .changeValue(NewsfeedFiltersData.empty, newsfeedFiltersFields.self),
        );
    }

    function hideFilters() {
        form.dispatch(form.actions().changeValue(false, showFiltersField));
    }

    $: showFilters = form.stores().fieldValue(showFiltersField);

    $: selectedCategory = form.stores().fieldValue(newsfeedFiltersFields.category);
    $: selectedSubCategory = form.stores().fieldValue(newsfeedFiltersFields.subCategory);

    $: _categoryItems = categoryItems($lang);
    $: category = _categoryItems.find((c) => c.value === $selectedCategory);
    $: subCategory = category?.children?.find((c) => c.value === $selectedSubCategory);
    $: categoryOptions = _categoryItems.map(toOption);
    $: subCategoryOptions = category?.children?.map(toOption) ?? [];
    $: typeOptions = subCategory?.children?.map(toOption) ?? [];

    function valueToOption(value: FeedPostTagEnum): SelectOption<FeedPostTagEnum> {
        return {
            value,
            label: t.feed_post.select_tag({ tag: value }, $lang),
        };
    }

    function toOption(c: ItemType<FeedPostTagEnum>) {
        return {
            value: c.value,
            key: c.value,
            label: t.feed_post.select_tag({ tag: c.value }, $lang),
        };
    }
</script>

<slot
    {resetFilters}
    {hideFilters}
    {newsfeedFiltersFields}
    selectedCategory={$selectedCategory}
    selectedSubCategory={$selectedSubCategory}
    {valueToOption}
    {categoryOptions}
    {subCategoryOptions}
    {typeOptions}
    showFilters={$showFilters}
/>
